import i18n from '@/lang/i18n'

export default function() {
    return [
        { type: 'customCheckbox' },
        {
            type: 'text',
            headerName: i18n.t('configuration.grid.code'),
            field: 'code',
            minWidth: 80,
            filter: false,
            sortable: false
        },
        {
            type: 'text',
            headerName: i18n.tc('configuration.sections.gender'),
            colId: 'nameTranslationKey',
            field: 'name',
            minWidth: 280,
            sortable: false,
            flex: 1
        },
        {
            type: 'checkIconRenderer',
            headerName: i18n.t('configuration.grid.active'),
            field: 'active',
            flex: 2
        },
        {
            type: 'flagsRenderer',
            headerName: i18n.t('configuration.grid.translations'),
            field: 'nameTranslations',
            filter: false,
            sortable: false,
            flex: 2
        }
    ]
}
